import { create } from "zustand";
import { RECHERCHER_PERM } from "../Utils/constant";
import { find } from "../services/service";
export const usePermStore = create((set) => ({
  loading: false,
  data: [],
  getData: async (id) => {
    set({
      loading: true,
      data: [],
    });
    try {
      const getItems = await find(`${RECHERCHER_PERM}?role=${id}`);
      setTimeout(() => {
        set({
          loading: false,
          data: getItems.data,
        });
      }, 1000);
    } catch (error) {
      set({
        loading: true,
        data: [],
      });
    }
  },
}));
